export const getPointDefaultPlannedDepartureMutateSingleVoyage = (): string | null => {
    return null
    // return moment(getFutureDay(1, DATE_FORMAT_POINT_SINGLE_VOYAGE), DATE_FORMAT_POINT_SINGLE_VOYAGE).toISOString()
}

export const getPointDefaultPlannedArrivalMutateSingleVoyage = (): string | null => {
    return null
    // return moment(getFutureDay(1, DATE_FORMAT_POINT_SINGLE_VOYAGE), DATE_FORMAT_POINT_SINGLE_VOYAGE).toISOString()
}
